__webpack_require__.p = "https://assets.khanoumi.com/4.155.0.0/_next/";